"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeHandleClassName = void 0;
const nativeHandleClassName = (variant, className) => `icon-default ${(variant === "filled" && "icon-filled ") || (variant === "outlined" && "icon-outlined ") || ""}${className ?? ""}`.trim();
exports.nativeHandleClassName = nativeHandleClassName;
